<script>
	import { getContext } from "svelte";
	import { tweened } from "svelte/motion";
	import { animationParameters } from "../constants";

	const { data, xGet, yGet, x, xScale, y, zGet, z, width } = getContext("LayerCake");

	export let color = "#000";
	export let opacity = 1;
	export let zIndex = undefined;

  export let hideAtTabletS = false;

	export let which = () => false;

	const w = 80;
	const w2 = w / 2;

	$: positionsX = $data.map((d) => $xGet(d) + ($xScale.bandwidth ? $xScale.bandwidth() / 2 : 0));
	const tPositionsX = tweened(positionsX, animationParameters);
	$: tPositionsX.set(positionsX);

	$: positionsY = $data.map((d) => $yGet(d));
	const tPositionsY = tweened(positionsY, animationParameters);
	$: tPositionsY.set(positionsY);
</script>

<div class="labels-group" class:hideAtTabletS={hideAtTabletS}>
	{#each $data as d, i}
		{@const h = which(d, i)}
		{#if h}
			{@const xPos = $tPositionsX[i]}
			{@const yPos = $tPositionsY[i]}
			{@const xValue = $x(d)}
			{@const yValue = $y(d)}
			{@const zValue = $z(d)}
			{@const xResult = $xGet(d)}
			{@const yResult = $yGet(d)}
			{@const zResult = $zGet(d)}
			{@const isNegative = yValue < 0}

			{@const xPosPx = (xPos / 100) * $width}
			{@const rightEdge = xPosPx > $width - w2}
			{@const leftEdge = xPosPx < w2}

			<div
				class="label"
				class:invert={isNegative}
				class:leftEdge
        class:rightEdge
				style:opacity
				style:color
				style:left="0"
        style:top="0"
        style:transform="translate({xPos}%, {yPos}%)"
				style:z-index={zIndex}
			>
				<slot
					{d}
					{rightEdge}
					{leftEdge}
					invert={isNegative}
					{yValue}
					{xValue}
					{zValue}
					{yResult}
					{xResult}
					{zResult}
				/>
			</div>
		{/if}
	{/each}
</div>

<style lang="scss">
  @import "../main.scss";

	.label {
		position: absolute;
    width: 100%;
    height: 100%;
    pointer-events: none;

    /*
    transform: translate(-50%, -100%);

		&.invert {
			transform: translate(-50%, 0);
    }
    */
  }

  @media (max-width: $breakpoint-tablet-s) {
		.hideAtTabletS {
			display: none;
    }
  }

</style>
